import React from "react";

export function Home() {
    return <div>Placeholder homepage</div>;
}
